module.exports = __webpack_public_path__ + "static/media/assembly.9f53bf96.png";